import { Stack, Typography } from "@mui/material";
import { PrimaryButton } from "Components/Shared/Buttons/PrimaryButton";
import { ModalDialog } from "Components/Shared/Dialogs/ModalDialog";
import { useNavigate } from "Navigation/useNavigate";
import { Resources, useResource } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";

const RESOURCES = Resources.Social.People;

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

/**
 * The HandleGate prompt: follow actions require a handle — a
 * handle-less caller is steered to the profile tab to pick one first. The backend
 * enforces the same rule (SocialErrors.HandleRequired); this dialog is the friendly path.
 */
export const HandleGateDialog = ({ isOpen, onClose }: Props) => {
  const { t } = useResource();
  const navigate = useNavigate();

  return (
    <ModalDialog
      isOpen={isOpen}
      onClose={onClose}
      title={t(RESOURCES.HandleGateTitle)}
    >
      <Stack gap={3}>
        <Typography>{t(RESOURCES.HandleGateText)}</Typography>
        <PrimaryButton
          fullWidth
          variant="contained"
          color="primary"
          onClick={() =>
            navigate(`${appUrl("user-account")}?activeTab=publicInformation`)
          }
        >
          {t(RESOURCES.HandleGateAction)}
        </PrimaryButton>
      </Stack>
    </ModalDialog>
  );
};
